module.exports = __webpack_public_path__ + "static/media/14.f04b6e1a.jpg";